import React from "react";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";

// @ts-ignore
import History from "../../utilities/History";
import { ISampleViewData } from "../../models/sample/SampleViewData";

import navigationHeaderActions from "../../flux/actions/NavigationHeaderActions";

import sampleActions from "../../flux/actions/SampleActions";
import sampleListStore from "../../flux/stores/sample/ListStore";
import * as CONSTANTS from "../../utilities/Constants";
import { RouteComponentProps } from "react-router";
import triggerNotifications from "../../utilities/TriggerNotifications";
import sampleEnableStore from "../../flux/stores/sample/EnableStore";
import sampleDisableStore from "../../flux/stores/sample/DisableStore";
import sampleDeleteStore from "../../flux/stores/sample/DeleteStore";
import { NOTIFICATION_TIMEOUT } from "../../utilities/Constants";
import { Translation } from "react-i18next";
import loadingActions from "../../flux/actions/LoadingActions";
import InfiniteScroll from "react-infinite-scroll-component";
import { Spinner, Dialog, Icon } from "@abb/abb-common-ux-react";
import { InputType } from "../../models/shared/IEnumTypes";
import sampleStatusStore from "../../flux/stores/sample/SampleStatusStore";
import sampleExportStore from "../../flux/stores/sample/ExportStore";
import measurementActions from "../../flux/actions/MeasurementActions";
import MeasurementRejectStore from "../../flux/stores/measurement/MeasurementRejectStore";
import MeasurementApproveStore from "../../flux/stores/measurement/MeasurementApproveStore";
import { SampleFormData } from "../../models/Sample/SampleFormData";
import MeasurementMultipleApproveStore from "../../flux/stores/measurement/MeasurementApproveMultipleStore";
import MeasurementMultipleRejectStore from "../../flux/stores/measurement/MeasurementRejectMultipleStore";
import SharedLoadingIndicator from "../shared/SharedLoadingIndicator";
import AbbTableComponentNew from "../shared/AbbTableComponentNew";
import settingsActions from "../../flux/actions/SettingsAction";
import { IExportOptions } from "../../models/settings/MeasurementSettings";
import i18next from "i18next";
type PropsType = RouteComponentProps & {};

interface TableState {
  list: ISampleViewData[];
  selected: string[];
  sortValue: string;
  sortStatus: string;
  sortOrder: string;
  sortName: string;
  previousState: ISampleViewData;
  downloadData: any;
  deleteModalVisible: boolean;
  selectedSampleForDelete: any[];
  searchValue: { key: String; value: String; type: String; sort: boolean }[];
  isSingleRowChecked: boolean;
  isMultipleRowChecked: boolean;
  showLoadingIndicator: boolean;
  sampleXML:boolean,
  measurementXML:boolean,
  measurementXLS:boolean,
  exportSample: boolean,
  exportMeasurement: boolean,
  fromDate: any,
  toDate: any
}

export default class SampleViewAll extends React.Component<
  PropsType,
  TableState
> {
  _mount = false;
  private _reloadFirst = true;
  private _messages: string[];
  private readonly _enableuuid: string;
  private readonly _disableuuid: string;
  private _page: number = 1;
  private _hasMore: boolean = true;
  private _listData: any;
  private _dropDownData: any = [];
  private _isMeasurementAproved: any = false;
  private _isMeasurementRejected: any = false;

  constructor(props: PropsType) {
    super(props);

    const previousState = this.props.location.state as ISampleViewData;
    this._mount = false;
    this._enableuuid = uuidv4();
    this._disableuuid = uuidv4();

    this.state = {
      list: [],
      selected: [],
      previousState,
      sortValue: CONSTANTS.SAMPLE_DATE,
      sortStatus: CONSTANTS.STATUS_ID,
      sortName: CONSTANTS.SORT_SAMPLEDATE,
      sortOrder: CONSTANTS.SORT_DESC_ORDER,
      deleteModalVisible: false,
      downloadData: {},
      selectedSampleForDelete: [],
      isSingleRowChecked: false,
      isMultipleRowChecked: false,
      showLoadingIndicator: false,
      searchValue: [
        { key: "check", value: "", type: InputType.BLANK, sort: false },
        { key: "Name", value: "", type: InputType.SEARCHBAR, sort: true },
        { key: "Product", value: "", type: InputType.SEARCHBAR, sort: true },
        { key: "Grade", value: "", type: InputType.SEARCHBAR, sort: true },
        { key: "TestPlan", value: "", type: InputType.SEARCHBAR, sort: true },
        { key: "Source", value: "", type: InputType.SEARCHBAR, sort: true },
        { key: "SampleDate", value: "", type: InputType.BLANK, sort: true },
        {
          key: "StatusId",
          value: "All",
          type: InputType.STATUS,
          sort: true,
        },
        { key: "UpdatedOn", value: "", type: InputType.BLANK, sort: true },
        { key: "filterIcon", value: "", type: InputType.BLANK, sort: false },
      ],
      sampleXML:false,
      measurementXML:false,
      measurementXLS:false,
      exportSample: false,
      exportMeasurement: false,
      fromDate: "",
      toDate: ""
    };
  }

  componentWillUnmount() {
    this._mount = false;
  }

  private GetExportOptions = () => {
    const request:string[] = [
      "ExportSample",
      "ExportMeasurement",
    ];
    settingsActions.getExportOptions(request).then((res:IExportOptions[])=>{
      if(res && res.length){
        let exportSample = false;
        let exportMeasurement = false;
        res.forEach((x:IExportOptions)=>{
          if (x.key === "ExportSample") {
            exportSample = x.value === "True" ? true : false
          } else if (x.key === "ExportMeasurement") {
            exportMeasurement = x.value === "True" ? true : false
          }
        })
        this.setState({
          exportSample,
          exportMeasurement
        })
      }

    }).catch((er)=>{console.log(er)});
  };

  componentDidMount() {
    this._mount = true;
    this.GetExportOptions();
    navigationHeaderActions
      .updateHeader({
        name: CONSTANTS.MODULE_STATION,
        action: "View All",
        icon: "abb/view",
        goBackUrl: CONSTANTS.SAMPLE_INDEX_URL,
        isGoBackWithData: false,
        goBackData: {},
        isDataChanged: false,
      })
      .then();

    sampleListStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._listData = [];
        if (
          state.sampleDataList.currentPage ===
            state.sampleDataList.totalPages ||
          state.sampleDataList.totalRecords === 0
        ) {
          this._hasMore = false; // it will show message
        } else {
          this._hasMore = true; // it will show spinner
        }
        this._listData = state.sampleDataList.result;
      }
    });

    sampleStatusStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this._dropDownData = [...state.data];
    });
    sampleEnableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._messages = state.messages;
        this._reloadFirst = state.reload;
        setTimeout(() => {
          this.getAll(true);
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });
    sampleDisableStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._messages = state.messages;
        this._reloadFirst = state.reload;
        setTimeout(() => {
          this.getAll(true);
        }, CONSTANTS.NOTIFICATION_TIMEOUT);
      }
    });
    sampleDeleteStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._messages = state.message;
        this._reloadFirst = state.reload;
        this.setState({ selectedSampleForDelete: [] });
        setTimeout(() => {
          this.getAll(true);
        }, 1000);
      }
    });
    sampleExportStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this.setState({
          downloadData: state.downloadData,
        });
      }
    });
    MeasurementRejectStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isMeasurementRejected = state.isMeasurementRejected;
      }
    });

    MeasurementMultipleRejectStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isMeasurementRejected = state.isMeasurementRejected;
      }
    });

    MeasurementApproveStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isMeasurementAproved = state.isMeasurementAproved;
      }
    });

    MeasurementMultipleApproveStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      if (this._mount) {
        this._isMeasurementAproved = state.isMeasurementAproved;
      }
    });

    this.getAll();
  }

  private getAll(isParams?: boolean) {
    if (isParams) {
      loadingActions.setLoading(true);
      let strConcat = "";
      let fromDate = "";
      let toDate = "";
      this.state.searchValue.forEach((item: any) => {
        if (item.value.length) {
          strConcat = item.key !== "SampleDate" ? strConcat + `${item.key}:${item.value}&` : strConcat;
          fromDate = this.state.fromDate;
          toDate = this.state.toDate;
        }
      });
      this._page = 1;
      sampleActions
        .getAllSampleData(
          true,
          1,
          CONSTANTS.PAGE_SIZE,
          this.state.sortName,
          this.state.sortOrder,
          strConcat,
          fromDate,
          toDate
        )
        .then(() => {
          loadingActions.setLoading(false);
          this.setState({ list: this._listData });
        })
        .catch(() => loadingActions.setLoading(false));
    } else {
      loadingActions.setLoading(true);
      this._page = 1;
      sampleActions
        .getAllSampleData(
          true,
          this._page,
          CONSTANTS.PAGE_SIZE,
          CONSTANTS.SORT_SAMPLEDATE,
          CONSTANTS.SORT_ORDER,
          "",
          "",
          ""
        )
        .then(() => {
          loadingActions.setLoading(false);
          this.setState({ list: this._listData, selectedSampleForDelete: [] });
          sampleActions
            .getSampleStatus()
            .then(() => {
              loadingActions.setLoading(false);
              this.setState({ selectedSampleForDelete: [] });
            })
            .catch(() => {
              loadingActions.setLoading(false);
            });
        })
        .catch(() => loadingActions.setLoading(false));
    }
  }

  private onEnableClick = (data: any) => {
    const sampleId = data.map((d: any) => d.id);
    sampleActions
      .enable(sampleId, this._enableuuid)
      .then(() => {
        setTimeout(() => {
          triggerNotifications.success(this._messages).then();
        }, NOTIFICATION_TIMEOUT);
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private onDisableClick = (data: any) => {
    let sampleId = [];
    sampleId = data.map((d: any) => d.id);
    sampleActions
      .disable(sampleId, this._disableuuid)
      .then(() => {
        triggerNotifications.success(this._messages).then();
        setTimeout(() => {});
      })
      .catch((error) => {
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private handleOnSelect = (row: any, isSelect: boolean) => {
    if (isSelect) {
      this.setState(() => ({
        selected: [...this.state.selected, row.id],
      }));
    } else {
      this.setState(() => ({
        selected: this.state.selected.filter((x) => x !== row.id),
      }));
    }
  };

  private openDialog = (data: any) => {
    this.setState({
      selectedSampleForDelete: data,
      deleteModalVisible: true,
    });
  };

  private editHandler = (value: any) => {
    const receivedData = value;
    const editData = new SampleFormData(
      true,
      uuidv4(),
      receivedData.id,
      receivedData.name,
      receivedData.description,
      receivedData.product?.id,
      receivedData.source?.id,
      receivedData.orderId,
      receivedData.setId,
      receivedData.sampleDate,
      receivedData.source?.name,
      receivedData.product?.name,
      "",
      receivedData.grade?.id,
      receivedData.testplan?.id
    );
    editData.gradeId = receivedData?.grade?.id;
    editData.gradeName = receivedData?.grade?.name;
    editData.testplanId = receivedData.testPlan?.id;
    editData.testplanName = receivedData.testPlan?.name;

    History.push(CONSTANTS.SAMPLE_CREATE_URL_NEW, editData);
  };

  private onExportClick = (data: any) => {
    let ids:string[] = [];
    if (Array.isArray(data)) {
      for (let i = 0; i < data.length; i++) {
        ids.push(data[i].id);
        sampleActions
          .exportAll(data[i].id, ids, 1, uuidv4(), null)
          .then(() => {
            if(i === data.length - 1){
              triggerNotifications.success(["Sample exported"]).then();
            }
          })
          .catch((messages) => {
            triggerNotifications.errors(messages);
          });
      }
    } else {
      ids.push(data.id);
      sampleActions
        .exportAll(data.id, ids, 1, uuidv4(), null)
        .then(() => {
          triggerNotifications.success(["Sample exported"]).then();
        })
        .catch((messages) => {
          triggerNotifications.errors(messages);
        });
    }
  };

  private onExportDataClick = (data: any) => {
    let ids:string[] = [];
    if (Array.isArray(data)) {
      for (let i = 0; i < data.length; i++) {
        ids.push(data[i].id);
        sampleActions
          .exportAll(data[i].id, ids, 2, uuidv4(), false)
          .then(() => {
            if(i === data.length - 1){
              triggerNotifications.success(["Measurement exported"]).then();
            }
          })
          .catch((messages) => {
            triggerNotifications.errors(messages);
          });
      }
      sampleActions
        .exportAll(data[0].id, ids, 2, uuidv4(), true)
        .then(() => {
          // triggerNotifications.success(["Measurement exported"]).then();
        })
        .catch((messages) => {
          triggerNotifications.errors(messages);
        });
    } else {
      ids.push(data.id);
      sampleActions
        .exportAll(data.id, ids, 2, uuidv4(), null)
        .then(() => {
          triggerNotifications.success(["Measurement exported"]).then();
        })
        .catch((messages) => {
          triggerNotifications.errors(messages);
        });
    }
  };

  // Download xlsx file
  private sampleDownloadXLSHandler = (data:any) => {
    let ids:string[] = [];
    if (Array.isArray(data)) {
      for (let i = 0; i < data.length; i++) {
        ids.push(data[i].id);
      }
    } else {
      ids.push(data.id);
    }
    sampleActions
      .exportWithMeasurementXLS(ids,uuidv4())
      .then(() => {
        triggerNotifications.success(["Measurement exported"]).then();
      })
      .catch((messages) => {
        triggerNotifications.errors(messages);
      });
  };

  // instrument actions
  private startInstrumentMeasurement = (data: any, multipleData: any) => {
    if (multipleData.length > 1) {
      const sampleIdList: any = [];
      multipleData.map((item: any) => {
        sampleIdList.push(item.id);
      });
      measurementActions
        .startMultipleMeasurement(sampleIdList, uuidv4())
        .then((res) => {
          triggerNotifications.success([CONSTANTS.SAMPLE_STARTING_MESSAGE]);
          setTimeout(() => {
            this.getAll(true);
            this.setState({
              isSingleRowChecked: false,
              isMultipleRowChecked: false,
              selectedSampleForDelete: [],
            });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    } else {
      measurementActions
        .startMeasurement(data.id, uuidv4())
        .then((res) => {
          triggerNotifications.success([CONSTANTS.SAMPLE_STARTING_MESSAGE]);
          setTimeout(() => {
            this.getAll(true);
            this.setState({
              isSingleRowChecked: false,
              isMultipleRowChecked: false,
              selectedSampleForDelete: [],
            });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    }
  };

  private remeasureInstrumentMeasurement = (data: any, multipleData: any) => {
    if (multipleData.length > 1) {
      const sampleIdList: any = [];
      multipleData.map((item: any) => {
        sampleIdList.push(item.id);
      });
      measurementActions
        .reMeasureMultipleMeasurement(sampleIdList, uuidv4())
        .then((res) => {
          triggerNotifications.success([CONSTANTS.SAMPLE_REMEASURED_MESSAGE]);
          setTimeout(() => {
            this.getAll(true);
            this.setState({
              isSingleRowChecked: false,
              isMultipleRowChecked: false,
              selectedSampleForDelete: [],
            });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    } else {
      measurementActions
        .reMeasureMeasurement(data.id, data.measurement)
        .then(() => {
          triggerNotifications.success([CONSTANTS.SAMPLE_REMEASURED_MESSAGE]);
          setTimeout(() => {
            this.getAll(true);
            this.setState({
              isSingleRowChecked: false,
              isMultipleRowChecked: false,
              selectedSampleForDelete: [],
            });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        })
        .catch((error: any) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    }
  };

  private measurementApprove = (data: any, multipleData: any) => {
    if (multipleData.length > 1) {
      const sampleArray: any = [];
      const measurementArray: any = [];
      multipleData.map((item: any) => {
        sampleArray.push(item.id);
        measurementArray.push(item.measurement);
      });
      measurementActions
        .approveMultipleSampleMeasurement(
          sampleArray,
          measurementArray,
          uuidv4()
        )
        .then((res) => {
          triggerNotifications.success([CONSTANTS.SAMPLE_APPROVED_MESSAGE]);
          setTimeout(() => {
            this.getAll(true);
            this.setState({
              isSingleRowChecked: false,
              isMultipleRowChecked: false,
              selectedSampleForDelete: [],
            });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    } else {
      measurementActions
        .approveSampleMeasurement(data.id, data.measurement, uuidv4())
        .then((res) => {
          triggerNotifications.success([CONSTANTS.SAMPLE_APPROVED_MESSAGE]);
          setTimeout(() => {
            this.getAll(true);
            this.setState({
              isSingleRowChecked: false,
              isMultipleRowChecked: false,
              selectedSampleForDelete: [],
            });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    }
  };

  private measurementReject = (data: any, multipleData: any) => {
    if (multipleData.length > 1) {
      const sampleArray: any = [];
      const measurementArray: any = [];
      multipleData.map((item: any) => {
        sampleArray.push(item.id);
        measurementArray.push(item.measurement);
      });
      measurementActions
        .rejectMultipleSampleMeasurement(
          sampleArray,
          measurementArray,
          uuidv4()
        )
        .then((res) => {
          triggerNotifications.success([CONSTANTS.SAMPLE_REJECTED_MESSAGE]);
          setTimeout(() => {
            this.getAll(true);
            this.setState({
              isSingleRowChecked: false,
              isMultipleRowChecked: false,
              selectedSampleForDelete: [],
            });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    } else {
      measurementActions
        .rejectSampleMeasurement(data.id, data.measurement, uuidv4())
        .then((res) => {
          triggerNotifications.success([CONSTANTS.SAMPLE_REJECTED_MESSAGE]);
          setTimeout(() => {
            this.getAll(true);
            this.setState({
              isSingleRowChecked: false,
              isMultipleRowChecked: false,
              selectedSampleForDelete: [],
            });
          }, CONSTANTS.NOTIFICATION_TIMEOUT);
        })
        .catch((error) => {
          triggerNotifications.errors(error.message, error.data).then();
        });
    }
  };

  private singleRowCheckedHandler = (value: any) => {
    this.setState({
      isSingleRowChecked: value,
    });
  };

  private multipleRowCheckedHandler = (value: any) => {
    this.setState({
      isMultipleRowChecked: value,
    });
  };

  private onDeleteClick = () => {
    let sampleId: any[];
    sampleId = this.state.selectedSampleForDelete.map((d: any) => d.id);
    loadingActions.setLoading(true);
    this.setState({ showLoadingIndicator: true });
    sampleActions
      .deleteMultiple(sampleId, this._disableuuid)
      .then(() => {
        setTimeout(() => {
          loadingActions.setLoading(false);                    
          triggerNotifications.success([i18next.t("Sample deleted")]).then();
        }, NOTIFICATION_TIMEOUT);
        this.setState({
          showLoadingIndicator: false,
          selectedSampleForDelete: [],
          deleteModalVisible: false,
          isSingleRowChecked: false,
          isMultipleRowChecked: false,
        });
      })
      .catch((error) => {
        loadingActions.setLoading(false);
        triggerNotifications.errors(error.message, error.data).then();
      });
  };

  private onSearch = (name: any, value: any, data: any) => {
    const items: any = [];
    this.state.searchValue.forEach((item) => {
      if (item.key === name) {
        items.push({
          key: item.key,
          value: value,
          sort: item.sort,
          type: item.type,
        });
      } else {
        items.push(item);
      }
    });

    let strConcat = "";
    let fromDate = "";
    let toDate = "";
    items.forEach((item: any) => {
      if (item.value.length) {
        if(item.key === "StatusId" && item.value === "Pending"){
          item.value = "NotMeasured"
        }
        strConcat = item.key !== "SampleDate" ? strConcat + `${item.key}:${item.value}&` : strConcat;
        fromDate = data.selectFromDate;
        toDate = data.selectToDate;
      }
    });
    if (value.length > CONSTANTS.SEARCH_LENGTH || value.length === 0) {
      loadingActions.setLoading(true);
      this.setState({fromDate: data.selectFromDate, toDate: data.selectToDate})
      this._page = 1;
      sampleActions
        .getAllSampleData(
          true,
          1,
          CONSTANTS.PAGE_SIZE,
          this.state.sortName,
          this.state.sortOrder,
          strConcat,
          fromDate,
          toDate
        )
        .then(() => {
          loadingActions.setLoading(false);
          this.setState({
            list: this._listData,
            searchValue: items,
            isSingleRowChecked: false,
            isMultipleRowChecked: false,
          });
        });
    } else {
      this.setState({ searchValue: items });
    }
  };

  public fetchMore = () => {
    loadingActions.setLoading(true);
    let strConcat = "";
    let fromDate = "";
    let toDate = "";
    this.state.searchValue.forEach((item: any) => {
      if (item.value.length) {
        strConcat = item.key !== "SampleDate" ? strConcat + `${item.key}:${item.value}&` : strConcat;
        fromDate = this.state.fromDate;
        toDate = this.state.toDate;
      }
    });
    this._page = this._page + 1;
    sampleActions
      .getAllSampleData(
        true,
        this._page,
        CONSTANTS.PAGE_SIZE,
        this.state.sortName,
        this.state.sortOrder,
        strConcat,
        fromDate,
        toDate
      )
      .then(() => {
        loadingActions.setLoading(false);
        const data = [...this.state.list, ...this._listData];
        this.setState({ list: data });
      })
      .catch(() => loadingActions.setLoading(false));
  };

  public onSortHandler = (name: any, value: any, order: any, data: any) => {
    this.setState(
      {
        sortValue: value,
        sortName: name,
        sortOrder: order,
      },
      () => {
        loadingActions.setLoading(true);
        let strConcat = "";
        let fromDate = "";
        let toDate = "";
        this.state.searchValue.forEach((item: any) => {
          if (item.value.length) {
            strConcat = item.key !== "SampleDate" ? strConcat + `${item.key}:${item.value}&` : strConcat;
            fromDate = data.selectFromDate;
            toDate = data.selectToDate;
          }
        });
        this._page = 1;
        this.setState({fromDate: data.selectFromDate, toDate: data.selectToDate})
        sampleActions
          .getAllSampleData(
            true,
            this._page,
            CONSTANTS.PAGE_SIZE,
            this.state.sortName,
            this.state.sortOrder,
            strConcat,
            fromDate,
            toDate
          )
          .then(() => {
            loadingActions.setLoading(false);
            this.setState({
              list: this._listData,
              selectedSampleForDelete: [],
            });
          })
          .catch(() => {
            loadingActions.setLoading(false);
          });
      }
    );
  };

  public clearFilter = () => {
    const searchValues = [
      { key: "check", value: "", type: InputType.BLANK, sort: false },
      { key: "Name", value: "", type: InputType.SEARCHBAR, sort: true },
      { key: "Product", value: "", type: InputType.SEARCHBAR, sort: true },
      { key: "Grade", value: "", type: InputType.SEARCHBAR, sort: true },
      { key: "TestPlan", value: "", type: InputType.SEARCHBAR, sort: true },
      { key: "Source", value: "", type: InputType.SEARCHBAR, sort: true },
      { key: "SampleDate", value: "", type: InputType.SEARCHBAR, sort: true },
      { key: "StatusId", value: "", type: InputType.DROPDOWN, sort: false },
      { key: "UpdatedOn", value: "", type: InputType.SEARCHBAR, sort: true },
      { key: "filterIcon", value: "", type: InputType.BLANK, sort: false },
    ];
    this.setState(
      {
        sortValue: CONSTANTS.SAMPLE_DATE,
        sortStatus: CONSTANTS.STATUS_ID,
        sortName: CONSTANTS.SORT_SAMPLEDATE,
        sortOrder: CONSTANTS.SORT_DESC_ORDER,
        searchValue: searchValues,
      },
      () => {
        this.getAll();
      }
    );
  };

  goBack = () => {
    History.push(CONSTANTS.SAMPLE_INDEXNEW_URL);
  };

  convertDropDownData = (data:any) => {
    const dropDownResponse = data.map((item:any) => {
      if(item.name === "NotMeasured"){
        item.name = "Pending"
      }
      return item
    })
    return dropDownResponse
  }

  convertListData = (data:any) => {
    const ListResponse = data.map((item:any) => {
      if(item.status.name === "NotMeasured"){
        item.status.name = "Pending"
      }
      return item
    })
    return ListResponse
  }

  public render() {
    return (
      <Translation>
        {(t) => (
          <div className="page-scroll">
            {this.state.showLoadingIndicator && <SharedLoadingIndicator />}
            <div className="app-container mt-4">
              <div className="container-box rounded-sm rounded-lg submit-header-fixed ml-1 viewall-page">
                <div>
                  <Icon
                    name="abb/caret-left"
                    sizeClass="large"
                    style={{ cursor: "pointer" }}
                    onClick={this.goBack}
                  />
                </div>
                <div className="viewall-page-title">
                  <span
                    className="title font-weight-bold mt-2 ml-1"
                    style={{ verticalAlign: "super" }}
                  >
                    {t(CONSTANTS.ALL_SAMPLES)}
                  </span>
                </div>
              </div>

              <div className="ml-1">
                <InfiniteScroll
                  dataLength={this.state.list.length} //This is important field to render the next data
                  next={this.fetchMore}
                  hasMore={this._hasMore}
                  loader={
                    <div>
                      <h6
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          textAlign: "center",
                        }}
                      >
                        <Spinner color="blue" sizeClass="medium" />
                      </h6>
                      <div></div>
                    </div>
                  }
                  scrollThreshold={0.5}
                  scrollableTarget="scrollableDiv"
                >
                  <AbbTableComponentNew
                    authKey={CONSTANTS.AUTHKEY_SAMPLE_MODE}
                    columns={[
                      {
                        dataField: "checkbox",
                        type: InputType.BLANK,
                        text: "",
                        style: { width: "5%" },
                        headerStyle: (colum, colIndex) => {
                          return { width: "20%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "name",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.MODULE_SAMPLE),
                        editable: false,
                        style: { width: "20%" },
                        headerStyle: (colum, colIndex) => {
                          return {
                            width: "25%",
                            textAlign: "left",
                            fontWeight: "bold",
                          };
                        },
                      },
                      {
                        dataField: "product.name",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.MODULE_PRODUCT),
                        editable: false,
                        style: { width: "20%" },
                        headerStyle: (colum, colIndex) => {
                          return {
                            width: "25%",
                            textAlign: "left",
                            fontWeight: "bold",
                          };
                        },
                      },
                      {
                        dataField: "grade.name",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.MODULE_GRADE),
                        editable: false,
                        style: { width: "20%" },
                        headerStyle: (colum, colIndex) => {
                          return {
                            width: "25%",
                            textAlign: "left",
                            fontWeight: "bold",
                          };
                        },
                      },
                      {
                        dataField: "testPlan.name",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.MODULE_TESTPLAN),
                        editable: false,
                        style: { width: "20%" },
                        headerStyle: (colum, colIndex) => {
                          return {
                            width: "25%",
                            textAlign: "left",
                            fontWeight: "bold",
                          };
                        },
                      },
                      {
                        dataField: "source.name",
                        type: InputType.SEARCHBAR,
                        text: t(CONSTANTS.MODULE_SOURCE),
                        editable: false,
                        style: { width: "20%" },
                        headerStyle: (colum, colIndex) => {
                          return {
                            width: "25%",
                            textAlign: "left",
                            fontWeight: "bold",
                          };
                        },
                      },
                      {
                        dataField: "formatedDate",
                        type: InputType.DATESEARCH,
                        text: t(CONSTANTS.SAMPLE_DATE),
                        editable: false,
                        style: { width: "10%" },
                        headerStyle: (colum, colIndex) => {
                          return { width: "20%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "status.name",
                        type: InputType.STATUS,
                        text: t(CONSTANTS.LABEL_STATUS),
                        editable: false,
                        style: { width: "10%" },
                        headerStyle: (colum, colIndex) => {
                          return { width: "10%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "updatedOn",
                        type: InputType.BLANK,
                        text: t(CONSTANTS.LABEL_DATE_MODIFIED),
                        editable: false,
                        style: { width: "10%" },
                        headerStyle: (colum, colIndex) => {
                          return { width: "20%", textAlign: "left" };
                        },
                      },
                      {
                        dataField: "filterIcon",
                        type: InputType.BLANK,
                        text: "",
                        editable: false,
                        style: { width: "5%" },
                        headerStyle: (colum, colIndex) => {
                          return { width: "5%", textAlign: "left" };
                        },
                      },
                    ]}
                    list={this.convertListData(this.state.list)}
                    dropDownData={this.convertDropDownData(this._dropDownData)}
                    searchValue={this.state.searchValue}
                    onSearchHandler={this.onSearch}
                    sortOrder={this.state.sortOrder}
                    sortValue={this.state.sortValue}
                    sortStatus={this.state.sortStatus}
                    onSortHandler={this.onSortHandler}
                    clearFilter={this.clearFilter}
                    select={false}
                    isFixedColumn={false}
                    isEditable={false}
                    delete={false}
                    isDisableAction={false}
                    isEnableAction={false}
                    viewAllPage={true}
                    DeleteAction={this.openDialog}
                    isDeleteAction={true}
                    editHandler={this.editHandler}
                    isSingleRowChecked={this.state.isSingleRowChecked}
                    singleRowCheckedHandler={this.singleRowCheckedHandler}
                    isMultipleRowChecked={this.state.isMultipleRowChecked}
                    multipleRowCheckedHandler={this.multipleRowCheckedHandler}
                    sampleExportHandler={this.onExportClick}
                    sampleDownloadHandler={this.onExportDataClick}
                    sampleDownloadXLSHandler={this.sampleDownloadXLSHandler}
                    remeasureMeasurementHandler={
                      this.remeasureInstrumentMeasurement
                    }
                    measurementHandler={this.startInstrumentMeasurement}
                    measurementApproveHandler={this.measurementApprove}
                    measurementRejectHandler={this.measurementReject}
                    handleOnSelect={this.handleOnSelect}
                    moduleName={CONSTANTS.ALL_SAMPLES}
                    selectedRowForDelete={this.state.selectedSampleForDelete}
                    isTitle={
                      <div className="float-left ml-1">
                      </div>
                    }
                    isSampleXml={this.state.sampleXML}
                    isMeasurementXml={this.state.measurementXML}
                    isMeasurementXlsx={this.state.measurementXLS}
                    exportSample={this.state.exportSample}
                    exportMeasurement={this.state.exportMeasurement}
                  />
                </InfiniteScroll>
              </div>
            </div>
            <Dialog
              isOpen={this.state.deleteModalVisible}
              // tslint:disable-next-line: jsx-no-lambda
              onClose={() => this.setState({ deleteModalVisible: false })}
              showCloseButton={true}
              closeOnEscape={false}
              closeOnLostFocus={false}
              dimBackground={true}
              title={t(CONSTANTS.DELETE_TITLE, {
                name: CONSTANTS.BUTTON_CONFIRM,
              })}
              standardButtonsOnBottom={[
                {
                  text: t(CONSTANTS.BUTTON_CANCEL),
                  type: "discreet-blue",
                  handler: (dlg) => dlg.close(),
                },
                {
                  text: t(CONSTANTS.BUTTON_OK),
                  type: "primary-blue",
                  handler: this.onDeleteClick,
                },
              ]}
            >
              <div>
                {t(CONSTANTS.DELETE_ALL_MESSAGE) +
                  "(" +
                  this.state.selectedSampleForDelete.length +
                  ") Sample(s) ?"}
                <br />
                <br />
                <b>{t(CONSTANTS.NOTE)}:</b> {t(CONSTANTS.DELETE_POPUP_MESSAGE)}
              </div>
            </Dialog>
          </div>
        )}
      </Translation>
    );
  }
}
